import { RootState } from 'store';

export const getLanguage = (state: RootState) => state.language;
